import { Injectable } from '@angular/core';
import { DataRelation, DataRelationDto } from '@osos/shared/api';
import { DataRelationPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class DataRelationsParserV1Service extends ParserBase<
  DataRelation,
  DataRelationPresenterModel
> {
  constructor() {
    super(DataRelation, DataRelationPresenterModel, 1);
  }
  getPresenterModel(model: DataRelationDto): DataRelationPresenterModel {
    const presenter = {
      specificationVersion: this.version,
    } as DataRelationPresenterModel;
    presenter.dataEntity = model.dataEntity;
    presenter.icon = model.icon;
    presenter.id = model.id;
    presenter.targetEntity = model.relatedData?.targetEntity;
    presenter.targetField = model.relatedData?.targetField;
    presenter.relationType = model.relationType;
    presenter.name = model.name;
    presenter.normalizedName = model.normalizedName;
    presenter.description = model.description;
    return presenter;
  }
  getDataModel(presenter: DataRelationPresenterModel): DataRelation {
    const model = {
      dataEntity: presenter.dataEntity,
      icon: presenter.icon,
      targetEntity: presenter.targetEntity.id,
      targetField: presenter.targetField.normalizedName,
      relationType: presenter.relationType,
      name: presenter.name,
      description: presenter.description,
      specificationVersion: this.version,
    } as DataRelation;

    return model;
  }
}
